<template>
  <div>
    <a-breadcrumb :routes="routes" class="customer-breadcrumb">
      <template slot="itemRender" slot-scope="{ route, routes }">
        <span v-if="routes.indexOf(route) === routes.length - 1">
          {{ route.breadcrumbName }}
        </span>
        <router-link v-else :to="route.path">
          <a-icon v-if="route.breadcrumbIcon" :type="route.breadcrumbIcon" />
          {{ route.breadcrumbName }}
        </router-link>
      </template>
    </a-breadcrumb>
  </div>
</template>

<script>
export default {
  data() {
    return {
      routes: []
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    }
  },
  beforeMount() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumbChildren(parentPath, routes) {
      return routes.map(route => {
        return {
          path: `${parentPath}/${route.path}`,
          breadcrumbName: route.meta.title,
          breadcrumbIcon: '' // route.meta.icon
        };
      });
    },

    getBreadcrumb() {
      this.routes = [
        {
          path: '/',
          breadcrumbName: '',
          breadcrumbIcon: 'home'
        }
      ];
      const routerItem = this.$router.options.routes[0];
      const routerMatches = this.$route.matched;
      let tempRouterItems = routerItem;
      for (const routerMatche of routerMatches) {
        tempRouterItems = tempRouterItems.children;
        for (const route of tempRouterItems) {
          if (route.path === routerMatche.path) {
            this.routes.push({
              path: '',
              breadcrumbName: routerMatche.meta.title,
              breadcrumbIcon: '', // routerMatche.meta.icon
              children: this.getBreadcrumbChildren(routerMatche.path, route.children)
            });
          }
        }
      }
      this.routes.push({
        path: '',
        breadcrumbName: routerMatches[routerMatches.length - 1].meta.title,
        breadcrumbIcon: ''
      });
    }
  }
};
</script>
